import React from "react";
import ShipmentDetail from "./shipmentDetail/ShipmentDetail";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import {useParams} from "react-router-dom/cjs/react-router-dom.min";
import ShipmentActivity from "./shipmentActivity/ShipmentActivity";
import TransferList from "./transferList/TransferList";

const ShipmentActivitiesDetail = () => {
    const stores = useStore();
    const {shipmentId} = useParams();

    const [shipmentActivitiesLoading, shipmentActivities] = useFetch({
        fetchFn: () =>
            stores.transferStore.transferShipmentActivities({
                shipmentId
            }),
        dependencies: [shipmentId],
        showLoading: true,
        initialCall: true
    });

    return (
        <div style={{display: "flex", flexDirection: "column", gap: "20px"}}>
            <ShipmentDetail shipmentInfo={shipmentActivities?.shipmentInfo} />
            <ShipmentActivity shipmentActivities={shipmentActivities?.shipmentActivities} />
            <TransferList transfers={shipmentActivities?.transfers} />
        </div>
    );
};

export default ShipmentActivitiesDetail;
